export const DEFAULT_LOCALE = "en" as const;

export enum LocaleStatus {
    BEGINNING = "BEGINNING",
    LITE = "LITE",
    TEST = "TEST",
    LIVE = "LIVE",
    ROCK_STAR = "ROCK_STAR",
}

// Adapted from third_party/vendored/third_party/babel/core.py
// sync-start:babel-aliases 954125190 https://github.com/Khan/webapp/blob/master/pkg/services_shared/intl/ka_locales.go
export const LOCALE_ALIASES = {
    ar: "ar-SY",
    bg: "bg-BG",
    bs: "bs-BA",
    ca: "ca-ES",
    cs: "cs-CZ",
    da: "da-DK",
    de: "de-DE",
    el: "el-GR",
    en: "en-US",
    es: "es-ES",
    et: "et-EE",
    fa: "fa-IR",
    fi: "fi-FI",
    fr: "fr-FR",
    gl: "gl-ES",
    he: "he-IL",
    hu: "hu-HU",
    id: "id-ID",
    is: "is-IS",
    it: "it-IT",
    ja: "ja-JP",
    km: "km-KH",
    ko: "ko-KR",
    lt: "lt-LT",
    lv: "lv-LV",
    mk: "mk-MK",
    nl: "nl-NL",
    nn: "nn-NO",
    no: "nb-NO",
    or: "or-IN",
    pl: "pl-PL",
    // We use pt-BR instead of pt-PT
    // pt: "pt-PT",
    ro: "ro-RO",
    ru: "ru-RU",
    sk: "sk-SK",
    sl: "sl-SI",
    sv: "sv-SE",
    th: "th-TH",
    tr: "tr-TR",
    uk: "uk-UA",

    // our own additions
    pt: "pt-BR",
    zh: "zh-hans",
} as const;
// sync-end:babel-aliases
